<template>
  <HXContentCard title="Honorarios Éxito / Producción">
    <!-- Filtros -->
    <div class="row m-3">
      <div class="col-12 px-1 mt-3 d-flex justify-content-end">
        <vs-button success flat icon :to="{ name: 'AgregarArchivoCuentaCobro' }">
          <i class="ti ti-upload mr-1"></i>
          Cargar documentos de cuenta de cobro
        </vs-button>
      </div>
      <div class="col-4 col-lg-3 px-0">
        <h4 class="mb-2"><b>Mes:</b></h4>
        <b-select v-model="mesSeleccionado" class="form-control bg-dark personalizado" :options="listaMes" text-field="mes" value-field="id" />
      </div>
      <div class="col-4 col-lg-2 px-1">
        <h4 class="mb-2"><b>Año:</b></h4>
        <b-select v-model="anioSeleccionado" class="form-control bg-dark personalizado" :options="listaAnios" />
      </div>
      <div class="col col-lg-1 px-0 mt-3">
        <vs-button primary icon class="px-2" @click="filtrar" id="sendform2">
          <i class="fas fa-search"></i>
        </vs-button>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-lg-6 mt-2" v-if="isAdmin">
            <h4 class="mb-2"><b>Filtrar x profesional:</b></h4>
            <v-select
              ref="selectProfesional"
              @input="obtenerDataProfesional()"
              class="style-chooser"
              :reduce="(value) => value"
              v-model="profesional"
              :options="listaProfesional"
              label="nombreProfesional"
              placeholder="-- selecciona un profesional --"
            >
              <div slot="no-options">No se encontraron resultados!</div>
            </v-select>
          </div>
          <div class="col-12 col-lg-6 mt-2" v-if="listaSucursal.length">
            <h4 class="mb-2"><b>Filtrar x sucursal:</b></h4>
            <v-select
              required
              ref="selectSucursal"
              class="style-chooser"
              :reduce="(value) => value"
              v-model="sucursal"
              :options="listaSucursal"
              label="sucursal"
              placeholder="-- selecciona opc. --"
              @input="filtrarDataPorSucursal()"
            >
              <div slot="no-options">No se encontraron resultados!</div>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <!-- {{ tablesProduccion[0].tables[0].data[0].fecha }} -->
    <!-- abr. 11012026  se agrega v-for porque en diciembre se hacen 2 liquidaciones, y se deben ser separadas -->
    <template v-for="(tablaProd, tindex) in tablesProduccion">
      <section v-if="estadoLiquidacion[tindex].estado == 1" class="p-4" :key="tindex">
        <!-- TOTALES HONORARIOS PARA ESA FECHA (opcional que sean por fecha o globales) -->
        <h3 v-if="fechas.length > 0" class="mb-3">
          <b>{{ "Liquidación del " + $moment(fechas[tindex].inicio).format("DD-MM-YYYY") + " al " + $moment(fechas[tindex].fin).format("DD-MM-YYYY") }}</b>
        </h3>
        <div class="d-flex mb-3 flex-wrap" style="gap: 1rem">
          <br />
          <div v-for="item in totalesHonorarios[tindex]" :key="item.id" class="py-2 px-4 bg-dark rounded">
            <span>{{ item.label }}</span
            ><br />
            <h2 class="font-weight-bold text-white-50">
              {{
                item.value.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })
              }}
            </h2>
          </div>
        </div>

        <!-- SECCIONES PARA ESTA FECHA -->
        <div class="m-0" v-for="sect in sectionsList" :key="sect.id">
          <div class="d-flex align-items-center py-3 border-bottom" v-b-toggle="'collapse-h-' + sect.id + '-' + tindex">
            <i :class="`fas fa-caret-${isOpen(sect.id, tindex) ? 'down incline' : 'right'} text-primary mr-1 fa-lg`"></i>
            <h3>
              <b>{{ sect.label }}</b>
            </h3>
          </div>

          <b-collapse :id="'collapse-h-' + sect.id + '-' + tindex" v-model="openMap[sect.id + '-' + tindex]" @input="onCollapseChange(sect.id, tindex, $event)">
            <!-- HONORARIOS PRODUCCION -->
            <div v-if="sect.id == 1" class="m-0 m-lg-3">
              <vs-button v-if="profesional" class="mt-2" icon flat @click="verResumen(tindex)">
                <i class="fas fa-file-lines mr-1"></i>
                Ver Resumen
              </vs-button>

              <section>
                <div v-for="item in tablaProd.tables" :key="item.id">
                  <div class="m-3">
                    <h4>
                      <b>{{ item.id }}. {{ item.title }}</b>
                    </h4>
                  </div>
                  <vs-table striped>
                    <template #notFound>
                      <span>No se encontraron resultados</span>
                    </template>
                    <template #header>
                      <vs-input v-model="item.search" border placeholder="Buscar..." />
                    </template>
                    <template #thead>
                      <vs-tr>
                        <vs-th v-for="(th, idx) in tablesProduccionSchema.columns" :key="idx" sort @click="item.data = $vs.sortData($event, item.data, th)">
                          {{ th }}
                        </vs-th>
                      </vs-tr>
                    </template>
                    <template #tbody>
                      <vs-tr v-for="row in $vs.getPage($vs.getSearch(item.data, item.search), item.page, max)" :data="row" :key="row.id">
                        <vs-td>{{ row.rut }}</vs-td>
                        <vs-td>{{ row.pacienteNombre }}</vs-td>
                        <vs-td>{{ row.concepto }}</vs-td>
                        <vs-td>{{ row.descripcion }}</vs-td>
                        <vs-td>{{ row.tipo }}</vs-td>
                        <vs-td>
                          {{
                            row.valor.toLocaleString("es-CO", {
                              style: "currency",
                              currency: "COP",
                            })
                          }}
                        </vs-td>
                      </vs-tr>
                    </template>
                    <template v-if="item.data?.length > 0" #footer>
                      <vs-pagination v-model="item.page" :length="$vs.getLength($vs.getSearch(item.data, item.search), max)" />
                    </template>
                  </vs-table>
                </div>
              </section>
            </div>

            <!-- HONORARIOS EXITO - Mostrar la liquidacion correspondiente a este periodo -->
            <div v-else class="m-0 mt-lg-3">
              <template v-if="honorariosExitoLiquidaciones[tindex]">
                <div class="mb-4">
                  <!-- Titulo con rango de fechas -->
                  <h4 class="mb-3 p-2 bg-dark rounded d-flex justify-content-between align-items-center flex-wrap">
                    <span>
                      <i class="fas fa-calendar-alt mr-2"></i>
                      {{ formatearFechaLiquidacion(honorariosExitoLiquidaciones[tindex].fechaInicio) }}
                      -
                      {{ formatearFechaLiquidacion(honorariosExitoLiquidaciones[tindex].fechaFin) }}
                    </span>
                    <small v-if="honorariosExitoLiquidaciones[tindex].fechaActualizacion" class="text-muted">
                      <i class="fas fa-clock mr-1"></i>
                      Actualizado:
                      {{ formatearFechaHora(honorariosExitoLiquidaciones[tindex].fechaActualizacion) }}
                    </small>
                  </h4>

                  <vs-table striped>
                    <template #notFound>
                      <span>No se encontraron resultados</span>
                    </template>
                    <template #thead>
                      <vs-tr>
                        <vs-th v-for="header in honorariosExitoLiquidaciones[tindex].headers" :key="header" :colspan="encabezadosCombinados(header)">
                          {{ header }}
                        </vs-th>
                      </vs-tr>
                    </template>
                    <template #tbody>
                      <!-- Primera fila (subheaders) -->
                      <vs-tr :data="honorariosExitoLiquidaciones[tindex].data[0]" key="header-row">
                        <vs-td v-for="(cell, idx) in honorariosExitoLiquidaciones[tindex].data[0]" :key="'header-' + idx">
                          {{ cell | formatValue(idx) }}
                        </vs-td>
                      </vs-tr>
                      <!-- Datos -->
                      <vs-tr v-for="(row, index) in honorariosExitoLiquidaciones[tindex].data.slice(1)" :key="'row-' + tindex + '-' + index" :data="row">
                        <vs-td v-for="(cell, idx) in row" :key="'cell-' + index + '-' + idx">
                          {{ cell | formatValue(idx) }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </template>
              <not-found v-else />
            </div>
          </b-collapse>
        </div>
      </section>
    </template>

    <!-- modal resumen -->
    <b-modal :title="'Resumen: ' + cadenaMes() + ' ' + anioSeleccionado" id="resumen" size="lg" hide-footer>
      <div class="p-2 mb-3 text-center">
        <h3>
          <b class="text-uppercase">
            <!-- {{ profesional?.nombreProfesional || "" }} -->
            {{ (profesional && profesional.nombreProfesional) || "" }}
          </b>
        </h3>
      </div>

      <div class="row px-3">
        <!-- <div v-for="rsm in tablesResumen" :key="rsm.id" class="col-12 col-lg-6 px-1 mt-2"> -->
        <div v-for="rsm in tablesResumen" :key="rsm.id" class="col-12 col-lg-6 px-1 mt-2">
          <div class="bg-dark p-2 font-weight-bold">
            <span :class="rsm.id === 12 && 'text-success'">
              {{ rsm.title }}
            </span>
            {{ rsm.id === 8 ? `(${PorcentajeSucursal}%)` : "" }}
          </div>
          <h3 class="pl-2 my-2">
            <b>
              {{
                rsm.total.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })
              }}</b
            >
          </h3>
        </div>
      </div>
    </b-modal>
  </HXContentCard>
</template>

<script>
import Swal from "sweetalert2";
import { tablesResumen, sectionsList, headersExito } from "./tablesSchema.js";
import { tablesProduccion as tablesProduccionSchema } from "./tablesSchema.js";
// import { parseISO, format, addDays } from "date-fns"; // ← Esto resuelve no-undef

import { listaMes } from "@/config/constants.js";

export default {
  components: {
    notFound: () => import("@/components/helexium/notFound.vue"),
  },
  data() {
    return {
      max: 10,
      // tablesProduccion: { ...tablesProduccion },
      tablesProduccionSchema, // solo para columns y plantilla
      tablesProduccion: [], // ← aquí estará 1 item por fecha
      tablesResumen: [...tablesResumen],
      sectionsList: [...sectionsList],
      headersExito: [...headersExito],
      listaMes: [...listaMes],
      honorariosExitoData: [],
      honorariosExitoLiquidaciones: [],
      listaAnios: [],
      mesSeleccionado: null,
      anioSeleccionado: null,
      persona: {},
      listaPacientes: [],
      listaProfesional: [],
      listaSucursal: [],
      listaItems: [],
      listaItemsbk: [],
      profesional: null,
      sucursal: null,
      listaItemsMaterial: [],
      listaLaboratorio: [],
      listaLaboratorioBk: [],
      listaItemsRemision: [],
      listattos: [],
      Periodo: {},
      otrosConceptos: [],
      otrosConceptosBk: [],
      totalAgregados: 0,
      totalDescuentos: 0,
      totalTtosRealizados: 0,
      totalCostosMaterial: 0,
      totalCostosRemision: 0,
      totalCostosLaboratorio: 0,
      totalNetoHonorarios: 0,
      PorcentajeSucursal: 0,
      TotalHonorarios: 0,
      totalFinalNetoHonorarios: 0,
      totalDescuentosExcluidos: 0,
      totalAgregadosExcluidos: 0,
      estadoLiquidacion: null,
      collasedMap: {},
      openMap: {},
      /////////*css*/`
      totalesPorFecha: {}, // { '2025-12-18T00:00:00': { totalTtosRealizados, totalCostosMaterial, ... }, ... }
      mistotalesGlobales: [],
      totalesGlobales: {
        // opcional, suma de todo
        totalTtosRealizados: 0,
        totalCostosMaterial: 0,
        totalCostosRemision: 0,
        totalCostosLaboratorio: 0,
        totalAgregados: 0,
        totalDescuentos: 0,
        totalNetoHonorarios: 0,
        TotalHonorarios: 0,
        totalAgregadosExcluidos: 0,
        totalDescuentosExcluidos: 0,
        totalFinalNetoHonorarios: 0,
      },
      mistotalesGlobalesData: [],
      fechas: [],
    };
  },
  async mounted() {
    this.getListaAnios();

    this.mesSeleccionado = new Date().getMonth();
    this.anioSeleccionado = new Date().getFullYear();

    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
  },
  computed: {
    fechasProduccion() {
      return Object.keys(this.listattos || {});
    },
    isAdmin() {
      return this.persona.rol.nivel >= 3;
    },
    totalesHonorarios() {
      try {
        let totalHonorariosTemporales = [];
        for (let i = 0; i < this.mistotalesGlobales.length; i++) {
          let honorariosExitoTotal = 0;

          // Obtener la liquidación correspondiente a este índice
          const liquidacion = this.honorariosExitoLiquidaciones[i];

          if (liquidacion && liquidacion.data && liquidacion.data.length > 1) {
            // data[0] son los subheaders, data[1] en adelante son los datos
            const dataRows = liquidacion.data.slice(1);

            if (i === 0) {
              // Primera liquidación: usar TOTAL (última columna)
              honorariosExitoTotal = dataRows.reduce((total, row) => total + (row[row.length - 1] || 0), 0);
            } else {
              // Segunda liquidación en adelante: usar Diferencia (penúltima columna)
              honorariosExitoTotal = dataRows.reduce((total, row) => total + (row[row.length - 1] || 0), 0);
            }
          }

          const totalHonorarios = this.mistotalesGlobales[i].totalFinalNetoHonorarios || 0;
          const totalGeneral = totalHonorarios + honorariosExitoTotal;

          totalHonorariosTemporales.push([
            {
              id: 1,
              label: "Honorarios de Producción",
              value: this.mistotalesGlobales[i].totalFinalNetoHonorarios,
            },
            {
              id: 2,
              label: "Honorarios de Éxito",
              value: honorariosExitoTotal,
            },
            { id: 3, label: "Total Honorarios", value: totalGeneral },
          ]);
        }
        console.log("totalHonorariosTemporales", totalHonorariosTemporales);
        return totalHonorariosTemporales;
      } catch (error) {
        console.error("Error en totalesHonorarios:", error);
        return [];
      }
    },
  },
  methods: {
    isOpen(sectId, tindex) {
      const key = `${sectId}-${tindex}`;
      return !!this.openMap[key]; // siempre boolean
    },
    onCollapseChange(sectId, tindex, val) {
      const key = `${sectId}-${tindex}`;
      this.$set(this.openMap, key, val); // true/false
    },

    generarIntervalos(clavesFechas) {
      if (!clavesFechas || clavesFechas.length === 0) return [];

      const inicioBase = new Date(this.anioSeleccionado, this.mesSeleccionado - 1, 1);
      const inicioBaseStr = inicioBase.toISOString().split("T")[0];

      return clavesFechas.map((clave) => {
        const parts = clave.split(",").map((p) => p.trim());
        const fechafin = parts[0];
        let fechainicio = parts[1] || "";

        // Fallback si fechainicio null/vacío/inválido
        if (!fechainicio || fechainicio === "null" || fechainicio === "undefined") {
          fechainicio = inicioBaseStr;
        } else {
          const fechaTest = new Date(fechainicio);
          if (isNaN(fechaTest.getTime()) || fechaTest.toISOString().split("T")[0] !== fechainicio) {
            fechainicio = inicioBaseStr;
          }
        }

        return { inicio: fechainicio, fin: fechafin };
      });
    },

    // generarIntervalos(fechasISO) {
    //   if (!fechasISO || fechasISO.length === 0) return [];

    //   // const inicioBase = "2025-12-01";
    //   const inicioBase = new Date(this.anioSeleccionado, this.mesSeleccionado - 1, 1);

    //   const fechasParseadas = fechasISO
    //     .map((fecha) => parseISO(fecha)) // Parsea ISO a Date
    //     .map((fecha) => format(fecha, "yyyy-MM-dd")) // Formato YYYY-MM-DD
    //     .sort(); // Ordena por si acaso

    //   const resultado = [];
    //   let finAnterior = inicioBase;

    //   for (let i = 0; i < fechasParseadas.length - 1; i++) {
    //     const fechaActual = fechasParseadas[i];
    //     resultado.push({ inicio: finAnterior, fin: fechaActual });
    //     const siguienteInicio = format(addDays(parseISO(fechaActual), 1), "yyyy-MM-dd");
    //     finAnterior = siguienteInicio;
    //   }

    //   // Último intervalo
    //   resultado.push({ inicio: finAnterior, fin: fechasParseadas[fechasParseadas.length - 1] });

    //   return resultado;
    // },
    actualizarTablas() {
      try {
        console.log("listaitems", this.listaItems);
        console.log("actualizando tablas", Object.keys(this.listaItems).length);

        // Combinar fechas de listaItems y otrosConceptos
        const fechasItems = Object.keys(this.listaItems || {});
        const fechasOtros = Object.keys(this.otrosConceptos || {});
        const fechas = [...new Set([...fechasItems, ...fechasOtros])]; // Unión de fechas únicas
        
        console.log("fechas encontradas:", fechas);
        this.fechas = this.generarIntervalos(fechas); // función externa para actualizar rangos de fechas en el header
        if (fechas.length === 0) {
          this.tablesProduccion = []; // no hay grupos => no hay collapses
        } else {
          this.tablesProduccion = fechas.map(() => ({
            tables: JSON.parse(JSON.stringify(this.tablesProduccionSchema.tables)),
            columns: this.tablesProduccionSchema.columns,
          }));
        }

        console.log("actualizando tablas, fechas:", fechas.length);
        console.log("instancias tablesProduccion:", this.tablesProduccion.length);

        for (let index = 0; index < fechas.length; index++) {
          const fecha = fechas[index];
          const itemsFecha = this.listaItems[fecha] || [];
          const otrosFecha = this.otrosConceptos[fecha] || [];
          const group = this.tablesProduccion[index];

          if (!group || !group.tables) {
            console.warn("tablesProduccion sin definir para index", index, group);
            continue;
          }

          group.tables[0].data = itemsFecha.filter((item) => item.concepto === "Ttos. realizados, cancelados y evolucionados");
          group.tables[1].data = itemsFecha.filter((item) => item.concepto === "Costos material especial");
          group.tables[2].data = itemsFecha.filter((item) => item.concepto === "Costos de remisión");
          group.tables[3].data = itemsFecha.filter((item) => item.concepto === "Costos Laboratorio");

          // Otros conceptos por fecha
          group.tables[4].data = otrosFecha;
        }

        console.log("tablesProduccion actualizadas", this.tablesProduccion);

        // limpiar paginaciones en todas las instancias
        this.tablesProduccion.forEach((group) => {
          group.tables.forEach((table) => {
            table.page = 1;
          });
        });
      } catch (error) {
        console.error("Error al actualizar tablas:", error);
      }
    },

    async obtenerDataProfesional() {
      // Limpiar variables acumuladas
      this.mistotalesGlobalesData = [];
      this.sucursal = null;
      
      let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
      let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
      this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
      console.log("periodo", this.Periodo);
      await this.obtenerData(this.Periodo.primerDia, this.Periodo.ultimoDia);
      // obtener otros conceptos
      await this.obtenerOtrosConceptos(this.Periodo.primerDia, this.Periodo.ultimoDia);
      console.log("otros conceptos", this.otrosconceptosbk);
      this.PorcentajeSucursal = 0;
      console.log("profesional--->", this.profesional);
      let Persona = await this.$store.dispatch("hl_get", {
        path: "Persona/GetPersonaPorDocumento/" + this.profesional.rut,
      });
      console.log("persona0", Persona);

      let dataProfesional = await this.$store.dispatch("hl_get", {
        path: "FormalEducation/GetByPersonaId/" + Persona.id + "/" + Persona.empresaId,
      });
      console.log("persona-->", dataProfesional);
      if (dataProfesional.length > 0) {
        this.dataProfesional = dataProfesional[0].degree;
      }

      this.listaSucursal = [...this.listaItems, ...this.otrosConceptosBk].reduce((acc, obj) => {
        if (obj.sucursal && !acc.includes(obj.sucursal)) {
          acc.push(obj.sucursal);
        }
        return acc;
      }, []);

      console.log("this.listaSucursal", this.listaSucursal);
    },
    getListaAnios() {
      const anioActual = new Date().getFullYear();
      const anioInicio = anioActual - 2;
      const listaAnios = [];

      for (let anio = anioInicio; anio <= anioActual; anio++) {
        listaAnios.push(anio);
      }
      this.listaAnios = listaAnios;
    },
    async filtrarDataPorSucursal() {
      console.log("filtrando por sucursal", this.sucursal);

      if (!this.sucursal) return;

      // Limpiar variables acumuladas
      this.mistotalesGlobalesData = [];

      // Filtros iniciales
      this.listaItems = this.listaItemsbk.filter((x) => x.sucursal == this.sucursal);
      this.otrosConceptos = this.otrosConceptosBk.filter((x) => x.sucursal == this.sucursal);
      this.listattos = this.listaItems.filter((x) => x.concepto == "Ttos. realizados, cancelados y evolucionados");
      this.listaItemsMaterial = this.listaItems.filter((x) => x.concepto == "Costos material especial");
      this.listaItemsRemision = this.listaItems.filter((x) => x.concepto == "Costos de remisión");
      this.listaLaboratorio = this.listaItems.filter((x) => x.concepto == "Costos Laboratorio");

      // Agrupaciones
      // this.otrosConceptos = this.otrosConceptos.reduce((acc, item) => {
      //   const key = item.fecha;
      //   if (!acc[key]) acc[key] = [];
      //   acc[key].push(item);
      //   return acc;
      // }, {});
      this.otrosConceptos = this.otrosConceptos.reduce((acc, item) => {
        const fecha1 = new Date(item.fecha).toISOString().split("T")[0];
        const fecha2 = new Date(item.fechaInicio).toISOString().split("T")[0];
        const key = `${fecha1}, ${fecha2}`; // "yyyy-mm-dd, yyyy-mm-dd"
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      // Agrupación listattos (antes de obtenerPorcentajeSucursal para mantener orden)
      this.listattos = this.listattos.reduce((acc, item) => {
        const fecha1 = new Date(item.fecha).toISOString().split("T")[0];
        const fecha2 = new Date(item.fechaInicio).toISOString().split("T")[0];
        const key = `${fecha1}, ${fecha2}`; // "yyyy-mm-dd, yyyy-mm-dd"
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      // CÁLCULOS ASÍNCRONOS - ESPERARLOS TODOS
      await Promise.all([
        this.obtenerPorcentajeSucursal(),
        this.getHonorariosExitoTemp(this.anioSeleccionado, this.mesSeleccionado),
        // Descomenta cuando esté listo:
        // this.calculoTotalesv2()
      ]);

      // Resto de agrupaciones (después de los awaits)
      this.listaItemsMaterial = this.listaItemsMaterial.reduce((acc, item) => {
        const fecha1 = new Date(item.fecha).toISOString().split("T")[0];
        const fecha2 = new Date(item.fechaInicio).toISOString().split("T")[0];
        const key = `${fecha1}, ${fecha2}`; // "yyyy-mm-dd, yyyy-mm-dd"
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      this.listaItemsRemision = this.listaItemsRemision.reduce((acc, item) => {
        const fecha1 = new Date(item.fecha).toISOString().split("T")[0];
        const fecha2 = new Date(item.fechaInicio).toISOString().split("T")[0];
        const key = `${fecha1}, ${fecha2}`; // "yyyy-mm-dd, yyyy-mm-dd"
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      this.listaLaboratorio = this.listaLaboratorio.reduce((acc, item) => {
        const fecha1 = new Date(item.fecha).toISOString().split("T")[0];
        const fecha2 = new Date(item.fechaInicio).toISOString().split("T")[0];
        const key = `${fecha1}, ${fecha2}`; // "yyyy-mm-dd, yyyy-mm-dd"
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      // this.listaItems = this.listaItems.reduce((acc, item) => {
      //   const key = item.fecha;
      //   if (!acc[key]) acc[key] = [];
      //   acc[key].push(item);
      //   return acc;
      // }, {});

      this.listaItems = this.listaItems.reduce((acc, item) => {
        const fecha1 = new Date(item.fecha).toISOString().split("T")[0];
        const fecha2 = new Date(item.fechaInicio).toISOString().split("T")[0];
        const key = `${fecha1}, ${fecha2}`; // "yyyy-mm-dd, yyyy-mm-dd"
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      // ✅ EJECUTAR AL FINAL, DESPUÉS DE TODO
      const fechas = Object.keys(this.listaItems); // después de agrupar por fecha

      // crear una instancia de tablesProduccion por fecha
      this.tablesProduccion = fechas.map(() => ({
        tables: JSON.parse(JSON.stringify(tablesProduccionSchema.tables)),
        columns: tablesProduccionSchema.columns,
      }));

      console.log("this.tablesProduccion --->", this.tablesProduccion);
      await this.calculoTotalesv2();

      this.actualizarTablas();
      this.$forceUpdate();
    },

    async calculoTotalesv2() {
      try {
        this.mistotalesGlobales = [];
        // Combinar fechas de listaItems y otrosConceptos para calcular totales
        const fechasItems = Object.keys(this.listaItems || {});
        const fechasOtros = Object.keys(this.otrosConceptos || {});
        const fechas = [...new Set([...fechasItems, ...fechasOtros])]; // Unión de fechas únicas
        console.log("fechas para totalesv2", fechas);
        this.totalesPorFecha = {};
        // reset globales
        Object.keys(this.totalesGlobales).forEach((k) => (this.totalesGlobales[k] = 0));

        for (const fecha of fechas) {
          const listattosFecha = this.listattos[fecha] || [];
          const materialFecha = this.listaItemsMaterial[fecha] || [];
          const remisionFecha = this.listaItemsRemision[fecha] || [];
          const laboratorioFecha = this.listaLaboratorio[fecha] || [];
          const otrosFecha = this.otrosConceptos[fecha] || []; // ojo: otrosConceptos también debe estar agrupado por fecha

          // 1) Totales base
          let totalTtosRealizados = listattosFecha.reduce((acc, currentItem) => {
            const v = Number(currentItem.valor) - Number(currentItem.valor) * parseFloat(currentItem.porcentajeLiquidacion || 0);
            return acc + v;
          }, 0);

          let totalCostosMaterial = materialFecha.reduce((acc, item) => acc + Number(item.valor || 0), 0);
          let totalCostosRemision = remisionFecha.reduce((acc, item) => acc + Number(item.valor || 0), 0);
          let totalCostosLaboratorio = laboratorioFecha.reduce((acc, item) => acc + Number(item.valor || 0), 0);

          let totalNetoHonorarios = totalTtosRealizados - totalCostosMaterial - totalCostosRemision - totalCostosLaboratorio;

          // 2) Excluidos porcentaje
          const listaAgregadosExcluidos = otrosFecha.filter((x) => x.tipo === "Agregado" && x.excluirPorcentaje);
          const totalAgregadosExcluidos = listaAgregadosExcluidos.reduce((acc, item) => acc + Number(item.valor || 0), 0);

          const listaDescuentosExcluidos = otrosFecha.filter((x) => x.tipo === "Descuento" && x.excluirPorcentaje);
          const totalDescuentosExcluidos = listaDescuentosExcluidos.reduce((acc, item) => acc + Number(item.valor || 0), 0);

          // 3) Agregados / descuentos con porcentaje
          const listaAgregados = otrosFecha.filter((x) => x.tipo === "Agregado" && !x.excluirPorcentaje);
          const totalAgregados = listaAgregados.reduce((acc, item) => acc + Number(item.valor || 0), 0);

          const listaDescuentosttos = otrosFecha.filter((x) => x.tipo === "Descuento" && !x.excluirPorcentaje);
          const totalDescuentosttos = listaDescuentosttos.reduce((acc, item) => acc + Number(item.valor || 0), 0);

          totalNetoHonorarios = totalNetoHonorarios + totalAgregados - totalDescuentosttos;

          // 4) Porcentaje sucursal
          const TotalHonorarios = (totalNetoHonorarios * this.PorcentajeSucursal) / 100;

          // 5) Aplicar excluidos
          const totalFinalNetoHonorarios = TotalHonorarios + totalAgregadosExcluidos - totalDescuentosExcluidos;

          // Guardar totales por fecha
          this.$set(this.totalesPorFecha, fecha, {
            totalTtosRealizados,
            totalCostosMaterial,
            totalCostosRemision,
            totalCostosLaboratorio,
            totalAgregados,
            totalDescuentos: totalDescuentosttos,
            totalNetoHonorarios,
            TotalHonorarios,
            totalAgregadosExcluidos,
            totalDescuentosExcluidos,
            totalFinalNetoHonorarios,
          });

          // Acumular globales
          this.mistotalesGlobales.push({
            totalTtosRealizados: totalTtosRealizados,
            totalCostosMaterial: totalCostosMaterial,
            totalCostosRemision: totalCostosRemision,
            totalCostosLaboratorio: totalCostosLaboratorio,
            totalAgregados: totalAgregados,
            totalDescuentos: totalDescuentosttos,
            totalNetoHonorarios: totalNetoHonorarios,
            TotalHonorarios: TotalHonorarios,
            totalAgregadosExcluidos: totalAgregadosExcluidos,
            totalDescuentosExcluidos: totalDescuentosExcluidos,
            totalFinalNetoHonorarios: totalFinalNetoHonorarios,
          });
        }

        console.log("totalesGlobales", this.mistotalesGlobales);
      } catch (error) {
        console.log("error", error);
      }
    },

    async obtenerPorcentajeSucursal() {
      try {
        this.$isLoading(true);
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ObtenerFullPorcentajeSucursal/" + this.sucursal + "/" + this.dataProfesional,
        });
        this.PorcentajeSucursal = res;
        console.log("this.PorcentajeSucursal ", this.PorcentajeSucursal);
        //abr 19022024
        if (this.PorcentajeSucursal.excepcion.toUpperCase().includes(this.profesional.nombreProfesional.toUpperCase())) {
          this.PorcentajeSucursal = this.PorcentajeSucursal.excepcion.split("-")[1];
        } else {
          this.PorcentajeSucursal = this.PorcentajeSucursal.porcentaje;
        }
        console.log("this.PorcentajeSucursal2 ", this.PorcentajeSucursal);
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        this.PorcentajeSucursal = 0;
        console.log("this.PorcentajeSucursal3 error", error);
      }
    },
    async getHonorariosExitoTemp(anio = null, mes = null) {
      try {
        this.$isLoading(true);

        // Mejorar la legibilidad de la creación de path
        const path = anio && mes ? `HonorariosExitoTemp/Obtener/${anio}/${mes}` : "HonorariosExitoTemp/Obtener";
        let res = await this.$store.dispatch("denti_get", { path });

        console.log("res", res);

        const { success, data } = res;
        if (success && data !== null) {
          // data ahora es un ARRAY de liquidaciones
          const liquidaciones = Array.isArray(data) ? data : [data];

          // Procesar cada liquidacion por separado
          this.honorariosExitoLiquidaciones = liquidaciones
            .map((liquidacion) => {
              const parsedData = JSON.parse(liquidacion.data);

              // Filtrar por sucursal y rut del profesional
              const foundData = parsedData.excelData.filter((row, idx) => (row[0] == this.sucursal && row[1] == this.profesional.rut) || idx === 0);

              return {
                id: liquidacion.id,
                fechaInicio: liquidacion.fechaInicio,
                fechaFin: liquidacion.fechaFin,
                fechaActualizacion: liquidacion.fechaActualizacion,
                headers: parsedData.headers,
                data: foundData,
              };
            })
            .filter((liq) => liq.data.length > 1); // Solo incluir si tiene datos (mas que el header)

          // Mantener compatibilidad para otros cálculos
          if (this.honorariosExitoLiquidaciones.length > 0) {
            this.honorariosExitoData = this.honorariosExitoLiquidaciones[0].data;
          } else {
            this.honorariosExitoData = [];
          }

          console.log("honorariosExitoLiquidaciones", this.honorariosExitoLiquidaciones);
        } else {
          console.log("No se encontraron datos");
          this.honorariosExitoData = [];
          this.honorariosExitoLiquidaciones = [];
        }

        this.$isLoading(false);
      } catch (error) {
        console.error("Error al obtener los honorarios:", error);
        this.$isLoading(false);
        this.showToast("error", "Hubo un error al obtener los honorarios");
      }
    },
    formatearFechaLiquidacion(fecha) {
      if (!fecha) return "";
      return this.$moment(fecha).format("DD/MM/YYYY");
    },
    formatearFechaHora(fecha) {
      if (!fecha) return "";
      return this.$moment(fecha).format("DD/MM/YYYY");
    },
    encabezadosCombinados(header) {
      if (header == "CIERRES DE ORTODONCIA") return 9;
      if (header == "IMPLANTES MONTADOS") return 2;
      if (header == "MONTAJES DE ORTODONCIA") return 4;
      if (header == "PACIENTES QUE INICIAN") return 3;
    },
    cadenaMes() {
      let numero = this.mesSeleccionado;
      const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      // Verificar que el número esté en el rango válido (1-12)
      if (numero < 1 || numero > 12) {
        return "Número inválido. Debe estar entre 1 y 12.";
      }

      // Restar 1 para obtener el índice correcto del mes
      return meses[numero - 1];
    },
    verResumen(index) {
      this.mistotalesGlobalesData.push(this.mistotalesGlobales[index]);
      this.tablesResumen[0].total = this.mistotalesGlobalesData[index].totalTtosRealizados;
      this.tablesResumen[1].total = this.mistotalesGlobalesData[index].totalCostosMaterial;
      this.tablesResumen[2].total = this.mistotalesGlobalesData[index].totalCostosRemision;
      this.tablesResumen[3].total = this.mistotalesGlobalesData[index].totalCostosLaboratorio;
      this.tablesResumen[4].total = this.mistotalesGlobalesData[index].totalAgregados;
      this.tablesResumen[5].total = this.mistotalesGlobalesData[index].totalDescuentos;
      this.tablesResumen[6].total = this.mistotalesGlobalesData[index].totalNetoHonorarios;
      this.tablesResumen[7].total = this.mistotalesGlobalesData[index].TotalHonorarios;
      this.tablesResumen[8].total = this.mistotalesGlobalesData[index].totalAgregadosExcluidos;
      this.tablesResumen[9].total = this.mistotalesGlobalesData[index].totalDescuentosExcluidos;
      this.tablesResumen[10].total = this.mistotalesGlobalesData[index].totalFinalNetoHonorarios;
      this.tablesResumen[11].total = this.mistotalesGlobales[index].totalFinalNetoHonorarios;
      console.log("mistotalesGlobalesData", this.mistotalesGlobalesData);
      this.$bvModal.show("resumen");
    },
    showToast(type, message) {
      console.log(type);
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      if (type == "warning")
        this.$toast.warning(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },

    async filtrar() {
      this.profesional = null;
      this.sucursal = null;
      ////////
      this.$isLoading(true);
      //abr: 28-03-2025 verificar estado de la liquidación del período seleccionado, si está en 0 o no existe en la tabla EstadoPeriodoLiquidacion no se debe visualizar la liquidación, esto sirve para que los profesionales no puedan ver la liquidación mientras Alejandra esté en el proceso de liquidar, cuando liquida todo pasamos el valor a 1
      await this.obtenerEstadoLiquidacion();
      console.log("estadoliquidacion ", this.estadoLiquidacion);

      let resultadoEstado = false;
      for await (let item of this.estadoLiquidacion) {
        console.log("item.estado ", item);
        if (item.estado == 1) {
          resultadoEstado = true;
        }
      }
      console.log("resultadoEstado ", resultadoEstado);
      //  if (this.estadoLiquidacion != null && this.estadoLiquidacion.estado == 1) {
      if (this.isAdmin) {
        this.estadoLiquidacion = [{ estado: 1 }, { estado: 1 }]; //temporal para pruebas
        resultadoEstado = true; //temporal para pruebas
      }

      if (this.estadoLiquidacion.length > 0 && resultadoEstado) {
        console.log("entro a filtrar");
        //filtrar x mes y año
        let mesSeleccionado = new Date(this.anioSeleccionado + "/" + this.mesSeleccionado + "/01").getMonth();
        let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();
        this.Periodo = this.obtenerPrimerYUltimoDiaDelMes(anioSeleccionado, mesSeleccionado);
        await this.getData(this.Periodo.primerDia, this.Periodo.ultimoDia);

        //  obtener data del profesional activo
        if (!this.isAdmin) await this.obtenerDataProfesional();
      } else {
        this.listaProfesional = [];
        Swal.fire("Aviso!", "Aún no hay datos disponibles para el período seleccionado.", "error");
      }

      this.$isLoading(false);
    },
    async obtenerData(primerDia, ultimoDia) {
      console.log("proff", this.profesional);
      this.listaItems = [];
      let res = await this.$store.dispatch("denti_get", {
        path: "Prestaciones/MiHonorarioPorProfesionalFecha/" + this.profesional.nombreProfesional + "/" + primerDia + "/" + ultimoDia,
      });
      console.log("otros", res);
      this.listaItems = res;
      this.listaItemsbk = res;
    },
    async obtenerOtrosConceptos(primerDia, ultimoDia) {
      this.otrosConceptos = [];
      let res = await this.$store.dispatch("denti_get", {
        path: "Prestaciones/ListaOtrosConceptosPorProfesional/" + primerDia + "/" + ultimoDia + "/" + this.profesional.nombreProfesional + "/",
      });
      console.log("otros conceptos en method", res);
      // this.otrosConceptos = res;
      this.otrosConceptosBk = res;
    },

    obtenerPrimerYUltimoDiaDelMes(anio, mes) {
      // El mes en JavaScript es base 0, por lo que enero es 0 y diciembre es 11
      const primerDia = new Date(anio, mes, 1);
      const ultimoDia = new Date(anio, mes + 1, 0); // El día 0 del mes siguiente es el último día del mes actual

      return {
        primerDia: primerDia.toISOString().split("T")[0], // Formato YYYY-MM-DD
        ultimoDia: ultimoDia.toISOString().split("T")[0],
      };
    },
    async getData(primerDia, ultimoDia) {
      try {
        console.log("getData", primerDia, ultimoDia, this.persona.numeroDocumento, this.persona.rutProfesional);

        this.listaItems = [];
        // console.log("getdata dentisalud", Periodo);

        const url = this.isAdmin
          ? `Prestaciones/ListaProfesionalesPorPeriodo/${primerDia}/${ultimoDia}`
          : `Prestaciones/GetProfesionalPorPeriodo/${primerDia}/${ultimoDia}/${this.persona.rutProfesional == null ? this.persona.numeroDocumento : this.persona.rutProfesional}`;

        let res = await this.$store.dispatch("denti_get", {
          path: url,
        });
        console.log("res dentisalud ", res);

        let uniqueProfesionales = new Set();

        if (this.isAdmin) {
          let idCounter = 1;
          this.listaProfesional = res
            .map((x) => {
              console.log("x-->0", x);
              let nombreProfesional = x.profesional.nombreProfesional;

              // Verificar si el nombreProfesional es único
              if (nombreProfesional && !uniqueProfesionales.has(nombreProfesional)) {
                uniqueProfesionales.add(nombreProfesional);
                return {
                  id: idCounter++, // ID incremental
                  nombreProfesional: nombreProfesional,
                  rut: x.profesional.rut,
                };
              }
              return null; // Ignorar duplicados
            })
            .filter((item) => item !== null); // Eliminar los nulls del array final

          console.log("lista profesionales", this.listaProfesional);
        } else {
          if (!res.data) {
            Swal.fire({
              icon: "info",
              title: "Sin resultados",
              text: "No se encontraron prestaciones.",
            });
            this.$isLoading(false);
            return;
          }
          this.profesional = res.data.profesional;
        }

        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);

        this.listaItems = [];
        console.log("err dentisalud ", error);
      }
    },
    async obtenerEstadoLiquidacion() {
      try {
        this.estadoLiquidacion = null;
        console.log("obtenerEstadoLiquidacion ", this.mesSeleccionado, this.anioSeleccionado);
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/EstadoPeriodoLiquidacion/" + this.mesSeleccionado + "/" + this.anioSeleccionado,
        });
        // let usuarioActual = JSON.parse(localStorage.getItem("setPersonaAct"));
        // console.log("usuarioActual", usuarioActual);
        // if (usuarioActual.rol.nivel == 4) {
        //   //si es admin siempre puede ver la liquidación
        //   this.estadoLiquidacion = { estado: 1 };
        // } else {
        this.estadoLiquidacion = res;
        // }
      } catch (error) {
        console.log("error", error);
        this.estadoLiquidacion = { estado: 0 };
      }
    },
  },
  filters: {
    formatValue(value, idx) {
      console.log("value", value);

      if (value === undefined || value === null) return "";

      const formatters = {
        currency: [6, 7, 10, 11, 12, 13, 14, 15, 16, 21, 25, 27, 31, 34, 35, 37, 40, 41, 42],
        date: [3],
        percentage: [8, 9, 20, 30],
        numberWithCommas: [4, 19, 29, 33],
      };

      if (typeof value === "number") {
        if (formatters.currency.includes(idx)) {
          // Formatear como moneda
          return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
          }).format(value);
        } else if (formatters.date.includes(idx)) {
          // Formatear como fecha (en caso de que sea un valor numérico de fecha de Excel)
          const excelEpoch = new Date(1899, 11, 30); // La fecha base de Excel es el 30 de diciembre de 1899
          const date = new Date(excelEpoch.getTime() + value * 86400000); // Convertir a milisegundos
          return date.toLocaleDateString("es-CO"); // Formatear la fecha en el formato deseado
        } else if (formatters.percentage.includes(idx)) {
          // Formatear como porcentaje
          return (value * 100).toFixed(1) + "%";
        } else if (formatters.numberWithCommas.includes(idx)) {
          // Redondear a un decimal y luego formatear con separadores de miles
          return new Intl.NumberFormat("es-CO").format(Math.round(value * 10) / 10);
        }
      }

      return value;
    },
  },
};
</script>
